/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2018/1/8 上午11:22
 */

import Portal from './Portal';

export default Portal;



// WEBPACK FOOTER //
// ./src/portal/index.js